import Head from 'next/head';
import React from 'react';

import { Container, useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Footer from '../components/Footer';
import Nav from '../components/NewNav';

const useStyles = makeStyles((theme) => ({
  nav: {
    [theme.breakpoints.up('sm')]: {
      backgroundColor: 'white',
    },
  },
  title: {
    color: '#000000',
    fontWeight: 'bold',
    fontSize: 40,
    lineHeight: '40px',
    textAlign: 'center',
    marginTop: 70,
    marginBottom: 40,
  },
}));

const Privacy = () => {
  const classes = useStyles({});
  const theme = useTheme();
  return (
    <>
      <Head>
        <title>Privacy Policy - Breezy</title>
      </Head>
      <Nav className={classes.nav} />
      <Container>
        <h1 className={classes.title}>Privacy Policy</h1>
        <p>
          Our Privacy Policy is here to make you aware of the information we may
          take and use while you visit our site. When you visit or use
          Sobreezy.com for any reason, you are understood to be in agreement
          with this Privacy Policy and our Terms of Use, which govern our site.
          If you are not in agreement with any part of this policy or our Terms
          of Use, please do not use Breezy.com or any of our services for any
          reason. For any terms not completely defined in this Privacy Policy,
          please refer to our Terms of Use for further explanation.
        </p>
        <p>
          We have the right to change or alter this Policy at any time we
          determine to be appropriate. Our website will always have the most up
          to date version live for your reference. With any update, it would be
          up to you to check the Privacy Policy and Terms of Use for any
          updates.
        </p>
        <p>Technical Visitor Information Collected by Sobreezy.com</p>
        <h2>1. General browsing:</h2>
        <p>
          {' '}
          This is the information we take from each visit made to Sobreezy.com.
          It may consist of, but is not limited to, the technical specifics of
          each visit; length of time on site, connectivity and download speed,
          and any other Site efficiencies we can measure. The information we are
          referring to in this Policy will be known as “Visitor Information.”
          Visitor Information allows Sobreezy.com to better provide our site
          visitors with the best possible website experience, because it
          increases our knowledge of each visitor and the journey taken while on
          our website. During the process of gathering Visitor Information,
          information such as IP address, service provider, domain type and
          browser version may also be collected in our efforts to better
          understand our Site visitors. Web beacons and cookies are also forms
          of information we may take. These forms of tracking technology help to
          keep your preferences up to date for future visits, by storing partial
          quotations for example. They also help us to keep all information
          displayed relevant to the visitor.
        </p>
        <p>
          If you wish, cookies may be turned off. This process varies by browser
          type, but mostly, you can find them in the settings section of your
          browser tab. However, keep in mind, some sites need cookies to
          function in the most effective manner, as would be the case with
          Sobreezy.com.
        </p>
        <h2>2. Information provided by you</h2>
        <p>
          In order for our insurer partners to provide you with tailored
          quotations, we need to disclose to our partners the information you
          provide us. We will also use your data for our own research and for
          tracking any purchased policies. By using Sobreezy.com, you agree that
          we may use your information in this way.
        </p>
        <p>
          Sobreezy.com will never ask for your social security number, any bank
          or payment information or anything else that could compromise you
          financially. We do not handle the buying process for your insurance
          and therefore we do not keep any payment information.
        </p>
        <p>
          We will not provide your information to any other parties without your
          permission, unless we are required to do so for legal reasons.
        </p>
        <p>
          We may use your data to keep you informed of other services and
          products that we offer and believe would be relevant to you.
        </p>
        <p>
          If you would rather us not keep you informed, then please send us an
          email to hi@sobreezy.com and we will remove you from our database.
        </p>
        <h2>3. How we use your personal information</h2>
        <p>
          Your personal information is used for the purpose of allowing you to
          receive insurance quotations.
        </p>
        <h2>4. Website security</h2>
        <p>
          When you get an insurance quote, or return to a previous quotation
          that is stored on our website, you will see that we use industry
          standard secure sockets layer (SSL) 128-bit encryption technology to
          ensure that your personal information is encrypted. Within all of our
          quotation pages, you will see a closed padlock at the bottom of your
          browser. We encrypt your data to safeguard your privacy from
          unauthorized access or improper use.
        </p>
        <h2>5. Links to other websites</h2>
        <p>
          Our website will provide links to other websites, which will be
          visible either before or after you get an insurance quotation.
        </p>
        <p>
          We do not endorse and we are not responsible for the content of any
          third party website visited from our website, nor are we responsible
          for the Privacy Policy or Terms of Business of any third party
          website. Before using any third party website, please take the
          opportunity to check their Privacy Policy and/or Terms of Business.
        </p>
        <h2>6. Personal information from children</h2>
        <p>
          Sobreezy.com does not knowingly collect any personal information from
          children under the age of 13. IF YOU ARE UNDER 13, PLEASE DO NOT USE
          THIS WEBSITE. We encourage parents and guardians to monitor their
          children’s internet usage and to help enforce this Privacy Policy by
          instructing their children not to enter any personal information
          through the internet without a parent or guardian’s permission. If you
          believe that a child under 13 has used this website to provide
          personal information then please get in touch with us at
          hi@sobreezy.com and we will remove the information from our database.
        </p>
      </Container>
      <Footer />
      <style jsx global>
        {`
          body {
            background-color: #f7f7fa !important;
          }
        `}
      </style>
      <style jsx>
        {`
          p {
            font-size: 16px;
            line-height: 36px;
            margin-top: 0;
            margin-bottom: 40px;
          }
          h2 {
            font-size: 16px;
            line-height: 36px;
            margin: 0;
          }
        `}
      </style>
    </>
  );
};

export default Privacy;
